import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m5.659 15.081.271-.492a.56.56 0 0 0-.402-.055zm-3.596.857-.548-.13a.562.562 0 0 0 .678.677zm.856-3.597.547.13a.56.56 0 0 0-.055-.401zM9 16.5A7.5 7.5 0 0 0 16.5 9h-1.125A6.375 6.375 0 0 1 9 15.375zm-3.613-.926A7.5 7.5 0 0 0 9 16.5v-1.125a6.34 6.34 0 0 1-3.07-.787zm-3.194.91 3.596-.856-.26-1.094-3.597.856zm.179-4.273-.857 3.596 1.095.26.856-3.595zM1.5 9c0 1.309.336 2.54.926 3.613l.985-.543A6.34 6.34 0 0 1 2.625 9zM9 1.5A7.5 7.5 0 0 0 1.5 9h1.125A6.375 6.375 0 0 1 9 2.625zM16.5 9A7.5 7.5 0 0 0 9 1.5v1.125A6.375 6.375 0 0 1 15.375 9z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      d: "M7.125 9v3.188h2.531a1.594 1.594 0 1 0 0-3.188zm0 0h2.344a1.594 1.594 0 1 0 0-3.187H7.125z"
    }, null, -1)
  ]))]))
}
export default { render: render }